import { Component, Input } from '@angular/core';

import { CoverageNetworkTypeEnum } from '../../enums/coverage-network-type.enum';
import { InsurancePlanLevelEnum } from '../../enums/insurance-plan-level.enum';
import { InsurancePlanAccumulators } from '@genesis-frontend/graphql';

@Component({
    selector: 'accumulators-section',
    templateUrl: './accumulators-section.component.html',
    styleUrls: ['./accumulators-section.component.scss']
})
export class AccumulatorsSectionComponent {
    @Input() insurancePlanAccumulators: InsurancePlanAccumulators | undefined = {} as InsurancePlanAccumulators;
    @Input() showAccumulator = {
        individual: false,
        family: false
    };
    @Input() networkFilter = CoverageNetworkTypeEnum.InNetwork;

    constants = {
        DEDUCTIBLE: 'Deductible',
        OUT_OF_POCKET_MAX: 'OutOfPocketMax'
    };
    insurancePlanLevel = InsurancePlanLevelEnum;

    isRelevantIndividualAccumulator(accumulator: any) {
        return accumulator?.network === this.networkFilter &&
            accumulator?.level === InsurancePlanLevelEnum.Individual &&
            (
                accumulator?.coverage === this.constants.DEDUCTIBLE ||
                accumulator?.coverage === this.constants.OUT_OF_POCKET_MAX
            );
    }

    isRelevantFamilyAccumulator(accumulator: any): boolean {
        return accumulator?.network === this.networkFilter &&
            accumulator?.level === InsurancePlanLevelEnum.Family &&
            (
                accumulator?.coverage === this.constants.DEDUCTIBLE ||
                accumulator?.coverage === this.constants.OUT_OF_POCKET_MAX
            );
    }
}
